import { SidebarItemProps } from '@cbhq/cds-web/navigation/SidebarItem';

import {
  ADVANCED_TRADING_DOCS_LINK,
  COINBASE_SIGNIN_DOCS_LINK,
  COMMERCE_DOCS_LINK,
  EXCHANGE_DOCS_LINK,
  ONRAMP_DOCS_LINK,
  PRIME_DOCS_LINK,
  VERIFICATION_LINK,
} from ':cloud/utils/links';
import { AppRoute } from ':cloud/utils/routes';

export type NavItem = SidebarItemProps & { id: string; pageTitle?: string };

/** @deprecated Use navigation.ts instead */
export const navItems: NavItem[] = [
  {
    title: 'Dashboard',
    id: 'project-dashboard',
    icon: 'newsfeed',
    to: AppRoute.Projects.DetailsTab,
  },
  {
    title: 'Legacy API keys',
    id: 'legacy-api',
    icon: 'key',
    to: AppRoute.Access.LegacyAPI,
  },
  {
    title: 'API keys',
    id: 'api',
    icon: 'key',
    to: AppRoute.Access.API,
  },
  { title: 'Team', id: 'team', icon: 'peopleGroup', to: AppRoute.Team.Home },
  {
    title: 'Earnings',
    id: 'earnings',
    icon: 'earnProduct',
    to: AppRoute.Earnings.Home,
  },
  {
    title: 'Billing',
    id: 'billing',
    icon: 'invoice',
    to: AppRoute.Billing.Home,
  },
  {
    title: 'Settings',
    id: 'project-settings',
    icon: 'settings',
    to: AppRoute.Settings.Project,
  },
  {
    title: 'Admin',
    id: 'admin',
    icon: 'browser',
    to: AppRoute.Admin.CurrentTab,
  },
  { title: 'Node', id: 'base', icon: 'nodeProduct', to: AppRoute.Products.Base },
  {
    title: 'Paymaster',
    id: 'bundler-paymaster',
    icon: 'gasFees',
    to: AppRoute.Products.BundlerAndPaymaster,
  },
  {
    title: 'Faucet',
    id: 'faucet',
    icon: 'faucet',
    to: AppRoute.Products.Faucet,
  },
  { title: 'WaaS', id: 'waas', icon: 'waasProduct', to: AppRoute.Products.Waas },
  {
    title: 'Wallets',
    id: 'waas_consumer',
    icon: 'waasProduct',
    to: AppRoute.Products.Wallets,
  },
  {
    title: 'Data',
    id: 'wallet_history',
    pageTitle: 'Data',
    icon: 'nodeProduct',
    to: AppRoute.Products.Indexers,
  },
  {
    title: 'Onramp',
    id: 'pay-docs',
    icon: 'payProduct',
    to: ONRAMP_DOCS_LINK,
  },
  {
    title: 'Verifications',
    id: 'verification',
    icon: 'securityShield',
    to: VERIFICATION_LINK,
  },
  {
    title: 'Onramp',
    id: 'pay',
    icon: 'payProduct',
    to: AppRoute.Products.Onramp,
  },
  {
    title: 'Components',
    id: 'onchainkit',
    icon: 'crystalBall',
    to: AppRoute.Products.Boat,
  },
];

/** @deprecated Use navigation.ts instead */
export const platformAPINavItems: readonly NavItem[] = [
  {
    title: 'Wallets',
    id: 'platform-wallets',
    icon: 'wallet',
    to: AppRoute.Products.PlatformWallets,
  },
  {
    title: 'Staking',
    id: 'staking',
    icon: 'staking',
    to: AppRoute.Products.Staking,
  },
];

/** @deprecated Use navigation.ts instead */
export const productAPINavItems: readonly NavItem[] = [
  {
    title: 'Advanced Trade',
    id: 'advanced-trade',
    icon: 'advancedTradeProduct',
    to: ADVANCED_TRADING_DOCS_LINK,
  },
  {
    title: 'Exchange',
    id: 'exchange-docs',
    icon: 'exchangeProduct',
    to: EXCHANGE_DOCS_LINK,
  },
  {
    title: 'Exchange',
    id: 'exchange',
    icon: 'exchangeProduct',
    to: AppRoute.Products.Exchange,
  },
  { title: 'Prime', id: 'prime', icon: 'primePoduct', to: PRIME_DOCS_LINK },
  {
    title: 'Commerce',
    id: 'commerce',
    icon: 'commerceProduct',
    to: COMMERCE_DOCS_LINK,
  },
  {
    title: 'Sign in with Coinbase',
    id: 'sign-in',
    icon: 'signinProduct',
    to: COINBASE_SIGNIN_DOCS_LINK,
  },
  {
    title: 'Participate',
    id: 'participate',
    icon: 'participateProduct',
    to: AppRoute.Participate.Home,
  },
];

/* this will replace the nav item in productAPINavItems
when we launch RAT onboarding */
export const advancedTradeNavItem: NavItem = {
  title: 'Advanced Trade',
  id: 'advanced-trade',
  icon: 'advancedTradeProduct',
  to: AppRoute.Products.AdvancedTrade,
};
